export default {
  title: 'Configurare îndepliniri pachete',
  form: {
    title: 'Creare îndeplinire',
    companies: {
      label: 'Companii',
    },
  },
  table: {
    title: 'Istoric îndepliniri',
    fields: {
      name: 'Companie',
      fulfilled: 'Îndeplinit la',
    },
  },
  buttons: {
    create_fulfillment: 'Creare îndeplinire',
  },
  toasts: {
    failed_to_load_data: 'Încărcarea datelor a eșuat',
    failed_to_create_fulfillment: 'Crearea îndeplinirii a eșuat',
  },
};
